export enum ReviewsSortingOption {
    LeastRecent = 'SubmissionTime:asc',
    MostRecent = 'SubmissionTime:desc',
    WorstRated = 'Rating:asc',
    BestRated = 'Rating:desc',
}
